import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['submitter'];

  connect() {
    this.element.addEventListener('turbo:submit-start', this.onSubmitStart);
  }

  disconnect() {
    this.element.removeEventListener('turbo:submit-start', this.onSubmitStart);
  }

  onSubmitStart = (e) => {
    const { formSubmission } = e.detail;

    if (this.submitterTargets.includes(formSubmission.submitter)) {
      const { body } = formSubmission;

      if (body instanceof FormData) {
        for (const [key, value] of body.entries()) {
          if (value instanceof File) {
            // this removes all entries with given key
            // may be more than just a file
            body.delete(key);
          }
        }
      }
    }
  };
}
